<template>
  <LightBox dense class="btn">
    <AppIcon v-if="icon" :icon="icon" size="large" start />
    <slot />
  </LightBox>
</template>

<script setup lang="ts">
defineProps<{
  icon?: string;
}>();
</script>

<style lang="scss" scoped>
.btn {
  cursor: pointer;
  text-align: center;
  color: #848484;
  font-size: 16px;
  padding: var(--space-4) var(--space-5);
  transition: all .2s;
  display: inline-block;

  &:hover {
    border-color: #848484;
    transform: translateY(-3px);
  }
}
</style>